// apiHelper.js
import Swal from "sweetalert2";

// URLs base disponibles
export const preurl = "https://backendgbl.continente.co/api/"; // Por defecto PHP
export const preurl2 = "https://backendsbco.continente.co/api/v2/"; // Node global

const getToken = () => localStorage.getItem("token_baken");

const clearSession = () => {
  localStorage.removeItem("token_baken");
  localStorage.removeItem("gestionar");
  localStorage.removeItem("usuario_actual");
  localStorage.removeItem("detallefiltro");
};

const handleSessionError = (reload = false) => {
  Swal.fire({
    icon: "error",
    title: "Sesión terminada",
    text: "Intente iniciando sesión nuevamente",
    showCancelButton: false,
    confirmButtonText: "OK",
  }).then(() => {
    clearSession();

    if (reload) {
      window.location.reload();
    }

    return "401";
  });
};

const handleApiError = (error, method = "") => {
  if (error.message === "Failed to fetch") {
    handleSessionError(method === "GET");
    return;
  }

  console.error(`Error al realizar la solicitud ${method}:`, error);

  Swal.fire({
    icon: "error",
    title: "Error durante el proceso",
    html: error.message,
  });
};

export const get = async (url, baseUrl = preurl) => {
  try {
    const token = getToken();

    const response = await fetch(baseUrl + url, {
      accept: "application/json",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      if (response.status === 400 || response.status === 500) {
        throw new Error("Failed to fetch");
      }

      const errorMessage = await response.text();

      throw new Error(
        `Error al obtener los datos. Código de estado: ${response.status}, Mensaje: ${errorMessage}`
      );
    }

    return await response.json();

  } catch (error) {
    handleApiError(error, "GET");
  }
};

export const post = async (url, dataform, baseUrl = preurl) => {
  try {
    const token = getToken();

    const response = await fetch(baseUrl + url, {
      method: "POST",
      body: dataform,
      accept: "application/json",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error al obtener los datos");
    }

    return await response.json();

  } catch (error) {
    handleApiError(error, "POST");
  }
};

export const put = async (url, dataform, baseUrl = preurl) => {
  try {
    const token = getToken();

    const response = await fetch(baseUrl + url, {
      method: "PUT",
      body: dataform,
      accept: "application/json",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return await response.json();

  } catch (error) {
    handleApiError(error, "PUT");
  }
};

export const remove = async (url, baseUrl = preurl) => {
  try {
    const token = getToken();

    const response = await fetch(baseUrl + url, {
      method: "DELETE",
      accept: "application/json",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return await response.json();

  } catch (error) {
    handleApiError(error, "DELETE");
  }
};

export const construirMensaje = (data, titulo, icono) => {
  let isjoson = false;

  try {
    JSON.parse(data);
    isjoson = true;
  } catch (error) {}

  if (isjoson) {
    const jsonObject = JSON.parse(data);

    let errores = "<ul>";

    for (const campo in jsonObject) {
      if (jsonObject.hasOwnProperty(campo)) {
        errores += `<li key=${campo}> ${jsonObject[campo][0]}</li>`;
      }
    }

    errores += "</ul>";

    Swal.fire({
      icon: icono,
      title: titulo,
      html: errores,
    });

  } else {
    Swal.fire({
      icon: icono,
      title: titulo,
      html: data,
    });
  }
};

export const parseBackendError = (errorMessage) => {
  try {
    if (Array.isArray(errorMessage)) {
      const parsed = JSON.parse(errorMessage[0]);

      return Object.values(parsed)
        .flat()
        .join("\n");
    }

    return errorMessage;

  } catch (e) {
    return "Error procesando el mensaje del servidor";
  }
};